export enum actionTypes {
  REQUEST_RBAC_RESOURCE_LIST = "request_rbac_resource_list",
  RECEIVED_RBAC_RESOURCE_LIST = "received_rbac_resource_list",
  COMPLETED_RBAC_RESOURCE_LIST = "completed_rbac_resource_list",
}